"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _screen = _interopRequireDefault(require("../../core/screen"));
var _index = require("../../connection/database/index");
var _actions = require("../../connection/database/actions");
var _classic = require("../classic");
var _signed_in_confirmation = require("../../core/signed_in_confirmation");
var _signed_up_confirmation = require("../../connection/database/signed_up_confirmation");
var _index2 = require("../../field/index");
var _actions2 = require("../../connection/enterprise/actions");
var _enterprise = require("../../connection/enterprise");
var l = _interopRequireWildcard(require("../../core/index"));
var i18n = _interopRequireWildcard(require("../../i18n"));
var _sign_up_pane = _interopRequireDefault(require("./sign_up_pane"));
var _pane_separator = _interopRequireDefault(require("../../core/pane_separator"));
var _sign_up_terms = _interopRequireDefault(require("../../connection/database/sign_up_terms"));
var _social_buttons_pane = _interopRequireDefault(require("../../field/social/social_buttons_pane"));
var _login_sign_up_tabs = _interopRequireDefault(require("../../connection/database/login_sign_up_tabs"));
var _single_sign_on_notice = _interopRequireDefault(require("../../connection/enterprise/single_sign_on_notice"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
var Component = function Component(_ref) {
  var i18n = _ref.i18n,
    model = _ref.model;
  var sso = (0, _classic.isSSOEnabled)(model, {
    emailFirst: true
  }) && (0, _index.hasScreen)(model, 'login');
  var ssoNotice = sso && /*#__PURE__*/_react.default.createElement(_single_sign_on_notice.default, null, i18n.str('ssoEnabled'));
  var tabs = !sso && (0, _index.hasScreen)(model, 'login') && /*#__PURE__*/_react.default.createElement(_login_sign_up_tabs.default, {
    key: "loginsignup",
    lock: model,
    loginLabel: i18n.str('loginLabel'),
    signUpLabel: i18n.str('signUpLabel')
  });
  var social = l.hasSomeConnections(model, 'social') && /*#__PURE__*/_react.default.createElement(_social_buttons_pane.default, {
    instructions: i18n.html('socialSignUpInstructions'),
    labelFn: i18n.str,
    lock: model,
    signUp: true
  });
  var signUpInstructionsKey = social ? 'databaseAlternativeSignUpInstructions' : 'databaseSignUpInstructions';
  var db = (l.hasSomeConnections(model, 'database') || l.hasSomeConnections(model, 'enterprise')) && /*#__PURE__*/_react.default.createElement(_sign_up_pane.default, {
    emailInputPlaceholder: i18n.str('emailInputPlaceholder'),
    i18n: i18n,
    instructions: i18n.html(signUpInstructionsKey),
    model: model,
    onlyEmail: sso,
    passwordInputPlaceholder: i18n.str('passwordInputPlaceholder'),
    passwordStrengthMessages: i18n.group('passwordStrength'),
    usernameInputPlaceholder: i18n.str('usernameInputPlaceholder')
  });
  var separator = social && db && /*#__PURE__*/_react.default.createElement(_pane_separator.default, null);
  return /*#__PURE__*/_react.default.createElement("div", null, ssoNotice, tabs, /*#__PURE__*/_react.default.createElement("div", null, social, separator, db));
};
var SignUp = exports.default = /*#__PURE__*/function (_Screen) {
  function SignUp() {
    _classCallCheck(this, SignUp);
    return _callSuper(this, SignUp, ['main.signUp']);
  }
  _inherits(SignUp, _Screen);
  return _createClass(SignUp, [{
    key: "submitButtonLabel",
    value: function submitButtonLabel(m) {
      return i18n.str(m, ['signUpSubmitLabel']);
    }
  }, {
    key: "submitHandler",
    value: function submitHandler(m) {
      if ((0, _classic.hasOnlyClassicConnections)(m, 'social')) return null;
      var username = (0, _index.databaseUsernameValue)(m, {
        emailFirst: true
      });
      if ((0, _enterprise.isHRDDomain)(m, username)) {
        return function (id) {
          return (0, _actions2.startHRD)(id, username);
        };
      }
      if ((0, _classic.isSSOEnabled)(m, {
        emailFirst: true
      })) return _actions2.logIn;
      return _actions.signUp;
    }
  }, {
    key: "isSubmitDisabled",
    value: function isSubmitDisabled(m) {
      return !(0, _index.termsAccepted)(m);
    }
  }, {
    key: "renderAuxiliaryPane",
    value: function renderAuxiliaryPane(lock) {
      return (0, _signed_up_confirmation.renderSignedUpConfirmation)(lock) || (0, _signed_in_confirmation.renderSignedInConfirmation)(lock) || (0, _index2.renderOptionSelection)(lock);
    }
  }, {
    key: "renderTabs",
    value: function renderTabs() {
      return true;
    }
  }, {
    key: "getScreenTitle",
    value: function getScreenTitle(m) {
      // signupTitle is inconsistent with the rest of the codebase
      // but, since changing this would be a breaking change, we'll
      // still support it until the next major version
      return i18n.str(m, 'signUpTitle') || i18n.str(m, 'signupTitle');
    }
  }, {
    key: "renderTerms",
    value: function renderTerms(m, terms) {
      var checkHandler = (0, _index.mustAcceptTerms)(m) ? function () {
        return (0, _actions.toggleTermsAcceptance)(l.id(m));
      } : undefined;
      return terms && (0, _index.showTerms)(m) ? /*#__PURE__*/_react.default.createElement(_sign_up_terms.default, {
        showCheckbox: (0, _index.mustAcceptTerms)(m),
        checkHandler: checkHandler,
        checked: (0, _index.termsAccepted)(m)
      }, terms) : null;
    }
  }, {
    key: "render",
    value: function render() {
      return Component;
    }
  }]);
}(_screen.default);
